module.exports = __webpack_public_path__ + "img/guide.081b2059.png";